import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useQueryClient } from "@tanstack/react-query";

export const useUserMutations = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const handleBanUser = async (userId: string, isBanned: boolean) => {
    try {
      const { error } = await supabase
        .from("profiles")
        .update({ banned: !isBanned })
        .eq("id", userId);

      if (error) throw error;

      toast({
        title: "Usuario actualizado",
        description: `El usuario ha sido ${!isBanned ? "bloqueado" : "desbloqueado"} correctamente.`,
      });

      queryClient.invalidateQueries({ queryKey: ["users"] });
    } catch (error) {
      console.error("Error updating user:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo actualizar el estado del usuario.",
      });
    }
  };

  const handleRoleChange = async (userId: string, newRole: string) => {
    try {
      const { error } = await supabase
        .from("profiles")
        .update({ role: newRole })
        .eq("id", userId);

      if (error) throw error;

      toast({
        title: "Rol actualizado",
        description: "El rol del usuario ha sido actualizado correctamente.",
      });

      queryClient.invalidateQueries({ queryKey: ["users"] });
    } catch (error) {
      console.error("Error updating role:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo actualizar el rol del usuario.",
      });
    }
  };

  return {
    handleBanUser,
    handleRoleChange,
  };
};